import React from "react";
import { useSelector } from "react-redux";
import { dayOfficeListSelector } from "../../selectors/BookSelectors";
import NoResult from "../Components/NoResult";
import { BookDayOfficeType } from "../../configs/DeclareType";
import DayOfficeListRender from "./DayOfficeListRender";
import CardPlaceholder from "../Desk/CardPlaceholder";

type Props = {
  loading: boolean;
};

const DayOfficeList = ({ loading }: Props) => {
  const dayOfficeListData: BookDayOfficeType[] = useSelector(
    dayOfficeListSelector
  );

  if (loading) {
    return <CardPlaceholder />;
  }

  if (!dayOfficeListData.length && !loading) {
    return <NoResult />;
  }

  return (
    <>
      <DayOfficeListRender data={dayOfficeListData} favoriteSection />
      <DayOfficeListRender data={dayOfficeListData} />
    </>
  );
};

export default DayOfficeList;
